export enum TagTheme {
  DEFAULT = 'default',
  ACTIVE = 'active',
  WHITE = 'white',
  SUSTAINABILITY = 'sustainability',
  SUCCESS = 'success',
  WARNING = 'warning',
  ALERT = 'alert',
  POPULAR = 'popular',
  BLACK_FRIDAY = 'black-friday',
  DISRUPTION = 'disruption',
  // new brand
  ERROR = 'error',
  PROMOTION = 'promotion',
  SEMI_PROMOTION = 'semi-promotion',
  DEFAULT_ON_BG = 'default-on-bg',
  DISABLED = 'disabled',
}

export enum TagRoundingStyle {
  DEFAULT = 'default',
  CHIP = 'chip',
  CURVE_LEFT = 'curve-left',
  CURVE_RIGHT = 'curve-right',
}
